import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';
import {
  Avatar,
  CreateAvatarBody,
  DeleteAvatarResponse,
  UpdateAvatarBody
} from '../../resources/types/avatarsTypes';

export const avatarsApi = createApi({
  reducerPath: 'avatarsApi',
  baseQuery,
  tagTypes: ['Avatars'],
  endpoints: builder => ({
    getAvatars: builder.query<{ data: Avatar[] }, void>({
      query: () => '/avatars',
      providesTags: ['Avatars']
    }),

    createAvatar: builder.mutation<{ data: Avatar }, CreateAvatarBody>({
      query: ({ file, name, isDefault }) => {
        const body = new FormData();
        // name і isDefault мають піти перед файлом: multer читає частини по
        // черзі, і в момент запису файла бачить лише попередні поля.
        if (name) {
          body.append('name', name);
        }
        if (isDefault) {
          body.append('isDefault', 'true');
        }
        body.append('file', file);

        return { url: '/avatars', method: 'POST', body };
      },
      invalidatesTags: ['Avatars']
    }),

    updateAvatar: builder.mutation<{ data: Avatar }, { name: string; body: UpdateAvatarBody }>({
      query: ({ name, body }) => ({
        url: `/avatars/${encodeURIComponent(name)}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['Avatars']
    }),

    deleteAvatar: builder.mutation<DeleteAvatarResponse, string>({
      query: name => ({
        url: `/avatars/${encodeURIComponent(name)}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Avatars']
    })
  })
});

export const {
  useGetAvatarsQuery,
  useCreateAvatarMutation,
  useUpdateAvatarMutation,
  useDeleteAvatarMutation
} = avatarsApi;
